// extracted by mini-css-extract-plugin
export var resizer = "_he-0";